/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Save_DraftInputs */

const en_case_save_draft = /** @type {(inputs: Case_Save_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save as draft`)
};

const pt_br2_case_save_draft = /** @type {(inputs: Case_Save_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvar rascunho`)
};

/**
* | output |
* | --- |
* | "Save as draft" |
*
* @param {Case_Save_DraftInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_save_draft = /** @type {((inputs?: Case_Save_DraftInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Save_DraftInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_save_draft(inputs)
	return pt_br2_case_save_draft(inputs)
});